module.exports = __webpack_public_path__ + "img/dooxSign.1873021c.png";